import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from "@angular/common/http";
import { Observable } from 'rxjs';
import { globals } from '../globals';
import { VendaItemModel } from '../dominio/venda-item-model';
import { QueryFilterService } from "../core/services/query-filter-service";
import { IGridifyQuery } from "gridify-client";

export interface ListarVendaItemLoteResponse {
  results: VendaItemModel[];
}

export interface DetalharVendaItemLoteResponse {
  result: VendaItemModel;
}

export interface AtualizarVendaItemLoteRequest {
  idLote?: number | null;
}

@Injectable({
  providedIn: "root",
})
export class VendaItemLoteService {
  constructor(private http: HttpClient, private queryFilterService: QueryFilterService) {}

  buscar(idCupom: number, queryFilter: IGridifyQuery | null = null): Observable<ListarVendaItemLoteResponse> {
    const params = this.queryFilterService.getQueryParams(queryFilter);

    return this.http.get<ListarVendaItemLoteResponse>(`${globals.apiUrl}/api/v2/core/vendas/${idCupom}/itens/lotes`, {
      params,
    });
  }

  atualizar(
    idCupom: number,
    idVendaItem: number,
    data: AtualizarVendaItemLoteRequest
  ): Observable<DetalharVendaItemLoteResponse> {
    return this.http.put<DetalharVendaItemLoteResponse>(
      `${globals.apiUrl}/api/v2/core/vendas/${idCupom}/itens/lotes/${idVendaItem}`,
      data
    );
  }

  baixarTodos(idCupom: number): Observable<Blob> {
    return this.http.get(`${globals.apiUrl}/api/v2/core/vendas/${idCupom}/itens/lotes/baixar-anexos`, {
      responseType: "blob",
    });
  }

  enviarEmail(idCupom: number, para: string, assunto: string, mensagem: string) {
    const data = { para, assunto, mensagem };

    return this.http.patch(`${globals.apiUrl}/api/v2/core/vendas/${idCupom}/itens/lotes/enviar-email`, data);
  }
}
